import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  let now = new Date(0);
  now.setMilliseconds(Date.now());

  return (!inject(AuthService).isTokenExpired())
    ? true
    : inject(Router).navigate(['/admin-portal/login']);
};
export const publicAuthGuard: CanActivateFn = (route, state) => {
  let now = new Date(0);
  now.setMilliseconds(Date.now());

  return (!inject(AuthService).isTokenExpired())
    ? true
    : inject(Router).navigate(['/public/member-directory']);
};
